import { required, numeric, minValue, maxValue, maxLength } from 'vuelidate/lib/validators'

const validaAnnounceHoldTime = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^yes$/g.test(value) || /^no$/g.test(value) || /^once$/g.test(value)
}
const validaAnnouncePosition = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^yes$/g.test(value) || /^no$/g.test(value) || /^limit$/g.test(value) || /^more$/g.test(value)
}

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    music: { required },
    strategy: { required },
    timeout: { required, numeric, minValue: minValue(5), maxValue: maxValue(99) },
    retry: { required, numeric, minValue: minValue(1), maxValue: maxValue(99) },
    wrapuptime: { required, numeric, minValue: minValue(0), maxValue: maxValue(99) },
    maxlen: { required, numeric, minValue: minValue(0), maxValue: maxValue(999) },
    announceFrequency: { numeric, minValue: minValue(5), maxValue: maxValue(999) },
    announceHoldTime: { validaAnnounceHoldTime },
    announcePositionLimit: { numeric, minValue: minValue(5), maxValue: maxValue(99) },
    announcePosition: { required, validaAnnouncePosition },
    priority: { required, numeric, minValue: minValue(0), maxValue: maxValue(99) },
    periodicAnnounceFrequency: { numeric, minValue: minValue(15), maxValue: maxValue(999) },
    tempoEspera: { required, numeric, minValue: minValue(0), maxValue: maxValue(999) },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Campo obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Código não pode ter mais de 30 dígitos.')
    return errors
  },
  musicErrors() {
    const errors = []
    if (!this.$v.form.music.$dirty) return errors
    !this.$v.form.music.required && errors.push('Campo obrigatório.')
    return errors
  },
  strategyErrors() {
    const errors = []
    if (!this.$v.form.strategy.$dirty) return errors
    !this.$v.form.strategy.required && errors.push('Campo obrigatório.')
    return errors
  },
  timeoutErrors() {
    const errors = []
    if (!this.$v.form.timeout.$dirty) return errors
    !this.$v.form.timeout.required && errors.push('Campo obrigatório.')
    !this.$v.form.timeout.numeric && errors.push('Apenas números.')
    !this.$v.form.timeout.minValue && errors.push('Menor valor: 5.')
    !this.$v.form.timeout.maxValue && errors.push('Maior valor: 99.')
    return errors
  },
  retryErrors() {
    const errors = []
    if (!this.$v.form.retry.$dirty) return errors
    !this.$v.form.retry.required && errors.push('Campo obrigatório.')
    !this.$v.form.retry.numeric && errors.push('Apenas números.')
    !this.$v.form.retry.minValue && errors.push('Menor valor: 1.')
    !this.$v.form.retry.maxValue && errors.push('Maior valor: 99.')
    return errors
  },
  maxlenErrors() {
    const errors = []
    if (!this.$v.form.maxlen.$dirty) return errors
    !this.$v.form.maxlen.required && errors.push('Campo obrigatório.')
    !this.$v.form.maxlen.numeric && errors.push('Apenas números.')
    !this.$v.form.maxlen.minValue && errors.push('Menor valor: 0.')
    !this.$v.form.maxlen.maxValue && errors.push('Maior valor: 999.')
    return errors
  },
  priorityErrors() {
    const errors = []
    if (!this.$v.form.priority.$dirty) return errors
    !this.$v.form.priority.required && errors.push('Campo obrigatório.')
    !this.$v.form.priority.numeric && errors.push('Apenas números.')
    !this.$v.form.priority.minValue && errors.push('Menor valor: 0.')
    !this.$v.form.priority.maxValue && errors.push('Maior valor: 99.')
    return errors
  },
  wrapuptimeErrors() {
    const errors = []
    if (!this.$v.form.wrapuptime.$dirty) return errors
    !this.$v.form.wrapuptime.required && errors.push('Campo obrigatório.')
    !this.$v.form.wrapuptime.numeric && errors.push('Apenas números.')
    !this.$v.form.wrapuptime.minValue && errors.push('Menor valor: 0.')
    !this.$v.form.wrapuptime.maxValue && errors.push('Maior valor: 99.')
    return errors
  },
  announceHoldTimeErrors() {
    const errors = []
    if (!this.$v.form.announceHoldTime.$dirty) return errors
    !this.$v.form.announceHoldTime.validaAnnounceHoldTime && errors.push('Opção inválida.')
    return errors
  },
  announcePositionErrors() {
    const errors = []
    if (!this.$v.form.announcePosition.$dirty) return errors
    !this.$v.form.announcePosition.required && errors.push('Campo obrigatório.')
    !this.$v.form.announcePosition.validaAnnouncePosition && errors.push('Opção inválida.')
    return errors
  },
  announcePositionLimitErrors() {
    const errors = []
    if (!this.$v.form.announcePositionLimit.$dirty) return errors
    !this.$v.form.announcePositionLimit.numeric && errors.push('Apenas números.')
    !this.$v.form.announcePositionLimit.minValue && errors.push('Menor valor: 5.')
    !this.$v.form.announcePositionLimit.maxValue && errors.push('Maior valor: 99.')
    return errors
  },
  announceFrequencyErrors() {
    const errors = []
    if (!this.$v.form.announceFrequency.$dirty) return errors
    !this.$v.form.announceFrequency.numeric && errors.push('Apenas números.')
    !this.$v.form.announceFrequency.minValue && errors.push('Menor valor: 5.')
    !this.$v.form.announceFrequency.maxValue && errors.push('Maior valor: 999.')
    return errors
  },
  periodicAnnounceFrequencyErrors() {
    const errors = []
    if (!this.$v.form.periodicAnnounceFrequency.$dirty) return errors
    !this.$v.form.periodicAnnounceFrequency.numeric && errors.push('Apenas números.')
    !this.$v.form.periodicAnnounceFrequency.minValue && errors.push('Menor valor: 15.')
    !this.$v.form.periodicAnnounceFrequency.maxValue && errors.push('Maior valor: 999.')
    return errors
  },
  tempoEsperaErrors() {
    const errors = []
    if (!this.$v.form.tempoEspera.$dirty) return errors
    !this.$v.form.tempoEspera.required && errors.push('Campo obrigatório.')
    !this.$v.form.tempoEspera.numeric && errors.push('Apenas caracteres numéricos são válidos.')
    !this.$v.form.tempoEspera.minValue && errors.push('Menor valor possível: 0.')
    !this.$v.form.tempoEspera.maxValue && errors.push('Maior valor possível: 999.')
    return errors
  },
}
